import LangEnum from '../../../../lang/LangEnum';
import useProductDetailsStore from '../../../../stores/ProductDetails/productDetails.store';
import { UsedInOfflineMode } from '../../../offline/types/UsedInOfflineMode';
import SuggestedProducts from '../../details/suggested-products/SuggestedProducts';
import ProductDetailsDescription from '../ProductDetailsDescription';
import { ProductDetailsSection } from '../hooks/useProductDetailsSections';
import { ProductDetailsAttribute } from '../types/productDetailsContent.types';
import { hasVisibleText } from '../utils/productDetailsContent.utils';
import CollapsibleSection from './CollapsibleSection/CollapsibleSection';
import ProductDetailsAttributes from './ProductDetailsAttributes';

interface ProductDetailsSectionsToggle {
  isSectionOpen: (section: ProductDetailsSection) => boolean;
  toggleSection: (section: ProductDetailsSection) => void;
}

interface ProductDetailsInfoSectionsProps extends UsedInOfflineMode {
  productId?: string;
  productColorId?: string;
  resume?: string | null;
  description?: string | null;
  attributes?: ProductDetailsAttribute[];
  scrollElement: HTMLElement | null;
  sections: ProductDetailsSectionsToggle;
}

const ProductDetailsInfoSections = ({
  productId,
  productColorId,
  resume,
  description,
  attributes,
  scrollElement,
  sections,
  isOfflineMode = false,
}: ProductDetailsInfoSectionsProps) => {
  const { isSectionOpen, toggleSection } = sections;

  const hasSuggestedProducts = useProductDetailsStore((state) => state.hasSuggestedProducts);
  const hasDescription = hasVisibleText(resume) || hasVisibleText(description);
  const hasAttributes = !!attributes?.length;
  const canShowRelated = !!productColorId && !!productId;

  return (
    <>
      {hasDescription && (
        <CollapsibleSection
          title={LangEnum.PRODUCT_DETAILS_INFO_DESCRIPTION}
          scrollElement={scrollElement}
          isOpen={isSectionOpen(ProductDetailsSection.DESCRIPTION)}
          onToggle={() => toggleSection(ProductDetailsSection.DESCRIPTION)}
        >
          <ProductDetailsDescription resume={resume} description={description} />
        </CollapsibleSection>
      )}

      {hasAttributes && (
        <CollapsibleSection
          title={LangEnum.GLOBAL_DETAILS}
          scrollElement={scrollElement}
          isOpen={isSectionOpen(ProductDetailsSection.DETAILS)}
          onToggle={() => toggleSection(ProductDetailsSection.DETAILS)}
        >
          <ProductDetailsAttributes attributes={attributes} />
        </CollapsibleSection>
      )}

      {canShowRelated && (
        <CollapsibleSection
          title={LangEnum.GLOBAL_RELATED}
          scrollElement={scrollElement}
          isOpen={isSectionOpen(ProductDetailsSection.RELATED)}
          isHidden={!hasSuggestedProducts}
          onToggle={() => toggleSection(ProductDetailsSection.RELATED)}
        >
          <SuggestedProducts
            isOfflineMode={isOfflineMode}
            productId={productId}
            productColorId={productColorId}
          />
        </CollapsibleSection>
      )}
    </>
  );
};

export default ProductDetailsInfoSections;
